function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgTwGreen = function SvgTwGreen(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      fill: "currentColor",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    viewBox: "0 0 28 28"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M9.446 24.5c9.246 0 14.304-7.408 14.304-13.821 0-.207 0-.417-.01-.625a10.034 10.034 0 0 0 2.51-2.52 10.46 10.46 0 0 1-2.892.767 4.916 4.916 0 0 0 2.215-2.69c-.987.566-2.068.963-3.195 1.174a5.095 5.095 0 0 0-2.853-1.471 5.191 5.191 0 0 0-3.189.511 4.938 4.938 0 0 0-2.21 2.282 4.717 4.717 0 0 0-.317 3.111A14.673 14.673 0 0 1 8.07 9.745a14.191 14.191 0 0 1-4.623-3.604 4.734 4.734 0 0 0-.548 3.542 4.874 4.874 0 0 0 2.106 2.946 5.217 5.217 0 0 1-2.275-.604v.067a4.765 4.765 0 0 0 1.138 3.076 5.064 5.064 0 0 0 2.892 1.689 5.052 5.052 0 0 1-1.324.17 5.095 5.095 0 0 1-.94-.084 4.871 4.871 0 0 0 1.788 2.414 5.147 5.147 0 0 0 2.908.957 10.308 10.308 0 0 1-6.248 2.083 9.92 9.92 0 0 1-1.194-.066A14.668 14.668 0 0 0 9.446 24.5Z",
    style: {
      fillRule: "nonzero",
      stroke: "CurrentColor",
      strokeWidth: 1
    }
  }));
};
export default SvgTwGreen;